import {
  defaultRaindropListFilter,
  raindropListColumnVisibilityOptions,
  defaultRaindropListColumnVisibility,
} from '@utils/tables/raindrop/raindropListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  raindropTableFilters: {},
  isCancelRaindropModalOpen: false,
  selectedRaindropId: '',
  selectedFilters: defaultRaindropListFilter,
  columnVisibility: defaultRaindropListColumnVisibility,
  columnVisibilityOptions: raindropListColumnVisibilityOptions,
};

const raindropTableSlice = createSlice({
  name: 'raindropTable',
  initialState,
  reducers: {
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setIsCancelRaindropModalOpen: (state, { payload }) => {
      state.isCancelRaindropModalOpen = payload;
    },
    setSelectedRaindropId: (state, { payload }) => {
      state.selectedRaindropId = payload;
    },
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setRaindropTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { raindropTableFilters } = state;
      const convertedValue = typeof value !== 'object' ? value : value[0];

      const newRaindropTableFilters = {
        ...raindropTableFilters,
        [codeName]: convertedValue,
      };
      state.raindropTableFilters = newRaindropTableFilters;
    },
    setClearRaindropTableFilters: (state) => {
      state.raindropTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: raindropTableReducer } = raindropTableSlice;
export const {
  setIsCancelRaindropModalOpen,
  setSelectedRaindropId,
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setRaindropTableFilters,
  setClearRaindropTableFilters,
} = raindropTableSlice.actions;
